import React, { useState } from 'react';
import { TextInput } from '../paper';
import DateTimePickerModal from '../DateTimePickerModal';

import * as Colors from '../../helpers/Colors';
import { TextField } from '../Input';
import moment from 'moment';

export type DateTimeFieldMode = 'datetime' | 'date' | 'time';

interface DateTimeFieldProps {
  name?: string;
  disabled?: boolean;
  value: string;
  mode?: DateTimeFieldMode;
  onValueChange?: ((...args: any[]) => any) | undefined;
}

const useLocalTime = (mode, value) =>
  useState(
    mode === 'datetime'
      ? moment.utc(value).local().toDate()
      : mode === 'date'
      ? moment(value, 'MM/DD/YYYY').toDate()
      : moment.utc(value, 'HH:mm:ss').local().toDate(),
  );

export const DateTimeField = ({
  name,
  disabled = false,
  value,
  mode = 'datetime',
  onValueChange,
}: DateTimeFieldProps) => {
  const [dateTimePickerVisible, setDateTimePickerVisibility] = useState(false);
  const [dateTime, setDateTime] = useLocalTime(mode, value);
  const hasSomeDate = typeof value === 'string' ? value.trim() !== '' : !!value;
  const localValue = hasSomeDate
    ? moment(dateTime).format(
        mode === 'datetime' ? 'MM/DD/YYYY hh:mm A' : mode === 'date' ? 'MM/DD/YYYY' : 'hh:mm A',
      )
    : '';

  const handlePressed = () => {
    if (!disabled) {
      setDateTimePickerVisibility(true);
    }
  };

  return (
    <>
      <TextField
        disabled={disabled}
        value={localValue}
        caretHidden
        showSoftInputOnFocus={false}
        onPressIn={handlePressed}
        right={
          <TextInput.Icon
            style={{ marginTop: 13 }}
            disabled={disabled}
            name="calendar-today"
            color={Colors.secondary}
            onPress={handlePressed}
          />
        }
      />

      <DateTimePickerModal
        isVisible={dateTimePickerVisible}
        mode={mode.toLowerCase() as 'datetime' | 'date' | 'time'}
        date={hasSomeDate ? dateTime : new Date()}
        onConfirm={(date) => {
          setDateTimePickerVisibility(false);
          setDateTime(date);

          let value: string;
          switch (mode.toLowerCase()) {
            case 'datetime':
              value = date.toISOString();
              break;
            case 'date':
              value = moment(date).format('MM/DD/YYYY');
              break;
            case 'time':
              value = moment(date).utc().format('HH:mm:ss');
              break;
          }

          if (name) {
            onValueChange?.(name, value);
          } else {
            onValueChange?.(value);
          }
        }}
        onCancel={() => setDateTimePickerVisibility(false)}
        themeVariant="light"
        isDarkModeEnabled={false}
      />
    </>
  );
};
